import React, { useEffect } from "react";
import { useApp } from "../../context/AppContext";
import { MarketingNav, MarketingFooter, L } from "../../components/marketing/MarketingChrome";
import Seo from "../../components/Seo";

// Shared shell for static legal pages: marketing chrome + a readable prose column.
export default function LegalLayout({ title, updated, children, testid, path, seoDescription }) {
  const { lang } = useApp();
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="bg-white min-h-screen flex flex-col" data-testid={testid}>
      <Seo path={path} title={`${title} - Cockpit OS`} description={seoDescription} />
      <MarketingNav />
      <main className="flex-1">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16">
          <h1 className="font-heading font-bold text-3xl sm:text-4xl tracking-tight text-slate-900">{title}</h1>
          <p className="text-sm text-slate-400 mt-2 mb-10">
            {L(lang, "Dernière mise à jour", "Last updated")} : {updated}
          </p>
          <div className="legal-prose space-y-6 text-slate-600 leading-relaxed text-[15px]">
            {children}
          </div>
        </div>
      </main>
      <MarketingFooter />
    </div>
  );
}

export function LegalSection({ heading, children }) {
  return (
    <section className="space-y-3">
      <h2 className="font-heading font-semibold text-lg text-slate-900">{heading}</h2>
      {children}
    </section>
  );
}
